var map = {
	"../pages/home/home.module": [
		1034,
		3
	],
	"../pages/order/order.module": [
		1035,
		2
	],
	"../pages/orders/orders.module": [
		1036,
		1
	],
	"../pages/settings/settings.module": [
		1037,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 288;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 288
// module chunks = 4